import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirplanemodeInactiveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airplanemode_inactive"}/>
}
